import { render, staticRenderFns } from "./MDsupport.vue?vue&type=template&id=5bf51490&scoped=true"
import script from "./MDsupport.vue?vue&type=script&lang=js"
export * from "./MDsupport.vue?vue&type=script&lang=js"
import style0 from "./MDsupport.vue?vue&type=style&index=0&id=5bf51490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf51490",
  null
  
)

export default component.exports